// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY ,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

// Initialize Firebase
console.log('🔥 Initializing Firebase with config:', firebaseConfig);

let app = null;
let database = null;
let isFirebaseReady = false;

try {
  app = initializeApp(firebaseConfig);
  console.log('✅ Firebase app initialized successfully');

  console.log('🔥 Attempting to initialize Realtime Database...');
  database = getDatabase(app);
  isFirebaseReady = true; // Set ready if getDatabase doesn't throw
  console.log('✅ Realtime Database initialized successfully');
  console.log('🔥 Database URL:', firebaseConfig.databaseURL);
  console.log('🔥 Database object:', database);
  console.log('🔥 isFirebaseReady:', isFirebaseReady);
  
} catch (error) {
  console.error('❌ Firebase initialization failed:', error);
  console.error('❌ Error details:', error.message);
  console.error('❌ Error code:', error.code);
  console.error('❌ Possible causes:');
  console.error('   1. Realtime Database not enabled in Firebase Console');
  console.error('   2. Incorrect database URL');
  console.error('   3. Network connectivity issues');
  console.error('   4. Check Firebase Console: https://console.firebase.google.com/');
  
  // Don't break the app, but log the error
  console.error('❌ App will continue with localStorage fallback');
  isFirebaseReady = false;
}

// Make test function available globally for debugging
if (typeof window !== 'undefined') {
  window.firebaseConfig = firebaseConfig;
  window.testFirebase = async () => {
    try {
      const { testFirebaseConnection } = await import('./actService');
      return testFirebaseConnection();
    } catch (error) {
      console.error('Error importing test function:', error);
      return false;
    }
  };
}

// Always export, even if null
export { app, database, isFirebaseReady };